import React, { useEffect, useState } from 'react';
import styles from './NavBar.module.css';
import { useScrollPosition } from "../hooks/ScrollPosition";
import { BiMenuAltLeft } from "react-icons/bi";
import { VscClose } from "react-icons/vsc";
import { FaFacebookF} from "react-icons/fa";
import { BiLogoTripAdvisor } from "react-icons/bi";
import { SiGooglemaps } from "react-icons/si";


const NavBar = () => {
    // Estados
    const [navBarOpen, setNavBarOpen] = useState(false);

    const [windowDimension, setWindowDimension] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const detectDimension = () => {
        setWindowDimension({
          width: window.innerWidth,
          height: window.innerHeight,
        });
    };
    
    useEffect(() => {
      window.addEventListener("resize", detectDimension);
      windowDimension.width > 800 && setNavBarOpen(false);
      return () => {
        window.removeEventListener("resize", detectDimension);
      };
    }, [windowDimension]);

    // Arreglo de objetos para los links del menú
    const links=[
      {
          id: 1,
          link: "INICIO",
          href: "/"
      },
      {
        id: 2,
        link: "HABITACIONES",
        href: "https://wa.me/c/593980202185"
      },
      {
        id: 3,
        link: "RESTAURANTE",
        href: "https://wa.me/c/593980202185"
      },
      {
        id: 4,
        link: "GOOGLE TRAVEL",
        href: "https://www.google.com/maps/dir//Hotel+Torre+Eiffel+Atacames+Malec%C3%B3n+de+Atacames/@0.8720347,-79.8519633,16z/data=!4m8!4m7!1m0!1m5!1m1!1s0x8fd4eceab416bc53:0x47c34842c936638a!2m2!1d-79.8519633!2d0.8720347?entry=ttu&g_ep=EgoyMDI1MDEyMi4wIKXMDSoASAFQAw%3D%3D"
      },
      {
        id: 5,
        link: "DESCUBRE ATACAMES",
        href: "https://www.tripadvisor.es/Tourism-g1725304-Atacames_Esmeraldas_Province-Vacations.html"
      },
    ]

    const scrollPosition = useScrollPosition();

    return (
      <div
        className={
          navBarOpen
            ? styles.navOpen
            : scrollPosition > 0
            ? styles.navOnScroll
            : styles.navBar
        }
      >
        <div className={styles.menu}>
          {windowDimension.width < 800 && (
            !navBarOpen ? (
              <div className={styles.iconMenu}>
                <BiMenuAltLeft
                  onClick={() => setNavBarOpen(!navBarOpen)}
                  color="#fff"
                  size={40}
                />
              </div>
            ) : (
              <span className="closeBtn">
                <VscClose
                  onClick={() => setNavBarOpen(!navBarOpen)}
                  color="#fff"
                  size={40}
                />
              </span>
            )
          )}

          {navBarOpen && (
            <ul className={styles.linksContainer}>
                {links.map(({ id, link, href }) => (
                    <div key={id}>
                        <a
                            href={href}
                            onClick={() => setNavBarOpen(false)}
                            className={styles.navLink}
                        >
                            {link}
                        </a>
                    </div>
                ))}
                <div className={styles.socialMediaContainer}>
                    <a href="https://facebook.com/elmejorlugarparaquedarse/" target="_blank" rel="noopener noreferrer">
                      <FaFacebookF size={40} />
                    </a>
                    <a href="https://tripadvisor.es/Hotel_Review-g1725304-d23977667-Reviews-Hotel_Torre_Eiffel_Atacames-Atacames_Esmeraldas_Province.html" target="_blank" rel="noopener noreferrer">
                      <BiLogoTripAdvisor  size={46} />
                    </a>
                    <a href="https://google.com/travel/hotels/entity/ChkIisfZyayI0uFHGg0vZy8xMWRfOWZiMHhmEAE?q=hotel%20torre%20eiffel%20atacames&ts=CAEaIAoCGgASGhIUCgcI6Q8QAhgUEgcI6Q8QAhgVGAEyAhAAKgkKBToDVVNEGgA&ictx=3&hl=es&qs=CAAgASgASAA&ap=KigKEglZ3hfUydvrPxHfQeIxmPZTwBISCTDZ9Vzp8-s_Ed9BYk119lPAMAA&ved=0CAAQ5JsGahcKEwiAoY2X5Y6LAxUAAAAAHQAAAAAQBA" target="_blank" rel="noopener noreferrer">
                      <SiGooglemaps size={40} />
                    </a>
                </div>
            </ul>
          )}
          
          {windowDimension.width > 800 && (
            <ul className={styles.linksContainer}>
              {links
                .map(({ id, link, href }) => (
                  <div key={id}>
                    <a
                      href={href}
                      className={styles.navLink}
                    >
                      {link}
                    </a>
                  </div>
              ))}
            </ul>
          )}
        </div>

        {!navBarOpen && (
          <a href="/" className={styles.logo}>
            <img src="/icons/logo_color.png" alt="Hotel Torre Eiffel"/>
          </a>
        )}
      </div>
    );
};

export default NavBar;
